import { useNavigate } from 'react-router-dom';
import axios from '../api/axiosInstance';
import { useState } from 'react';
import './ConsentRequired.css';

const ConsentRequired = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleConsent = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Brak tokena. Zaloguj się ponownie.');
      navigate('/login');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const response = await axios.patch('/api/user/consent', { consentGiven: true });
      if (response.data.requireLogout) {
        localStorage.removeItem('token');
        navigate('/login');
        return;
      }
      // Jeśli nie wymagane wylogowanie, przekieruj na stronę główną
      navigate('/');
    } catch (err) {
      console.error(err);
      setError('Wystąpił błąd podczas zapisu zgody.');
      setSubmitting(false);
    }
  };

  return (
    <div className="consent-container">
      <div className="consent-card">
        <h2 className="consent-title">
          Wymagana zgoda na przetwarzanie danych
        </h2>
        <p className="consent-description">
          Aby korzystać z aplikacji x-spot, musisz wyrazić zgodę na to,
          że Twoja nazwa użytkowniak i numer rejestracyjny będą widoczne dla innych pracowników
          w kontekście rezerwacji miejsc parkingowych.
          Po akceptacji nastąpi wylogowania. Zaloguj się ponownie.
        </p>

        {error && <p className="consent-error">{error}</p>}

        <button
          onClick={handleConsent}
          disabled={submitting}
          className="consent-button"
        >
          {submitting ? 'Zapisywanie...' : 'Rozumiem i akceptuję'}
        </button>
      </div>
    </div>
  );
};

export default ConsentRequired;
